/* 🤖 this file was generated by svg-to-ts */
export const matIconToll: {
  name: 'toll';
  data: string;
} = {
  name: 'toll',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M15 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zM3 12a5.99 5.99 0 0 1 4-5.65V4.26C3.55 5.15 1 8.27 1 12s2.55 6.85 6 7.74v-2.09A5.99 5.99 0 0 1 3 12z"/></svg>`
};
